import React from 'react';
import { IconButton, InputAdornment, TextField } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import FolderIcon from '@mui/icons-material/Folder';

export const FolderRow = ({
	error,
	editable = false,
	disabled = false,
	onDelete,
	...props
}) => (
	<TextField
		variant='outlined'
		size='small'
		fullWidth
		placeholder='Folder name'
		{...props}
		disabled={!editable || disabled}
		error={Boolean(error)}
		helperText={error || undefined}
		InputProps={{
			startAdornment: (
				<InputAdornment position='start'>
					<FolderIcon sx={{ color: '#fbce3a' }} />
				</InputAdornment>
			),
			endAdornment: editable ? (
				<InputAdornment position='end'>
					<IconButton
						aria-label='delete'
						size='small'
						disabled={disabled}
						onClick={onDelete}
						sx={{ color: 'primary.main' }}
					>
						<DeleteIcon fontSize='small' />
					</IconButton>
				</InputAdornment>
			) : null,
		}}
	/>
);

export default FolderRow;
